export const technologies = [
  { id: 1, icon: "barChart3", name: "Analytics" },
  { id: 2, icon: "users", name: "CRM" },
  { id: 3, icon: "zap", name: "Marketing Automation" },
  { id: 4, icon: "sparkles", name: "AI & ML" },
  { id: 5, icon: "database", name: "Data Intelligence" },
  { id: 6, icon: "cloud", name: "Cloud Infrastructure" },
  { id: 7, icon: "search", name: "SEO Tooling" },
  { id: 8, icon: "mail", name: "Email Marketing" },
];
